let version = 0;
let versionBar = 1.5;

class AppHelper {
  static formatUrl = url => {
    const isAndroid = /(android)/i.test(navigator.userAgent);
    if (url.includes("sig=") && isAndroid && !this.skipUrlEncode()) {
      if (url) var search = url.split("?")[1];
      var sigValue = url.split("sig=")[1].split("&se=")[0];

      return url.replace(sigValue, encodeURIComponent(sigValue));
    }
    return url;
  };

  static formatToTimeString = milliseconds => {
    let totalSeconds = Math.round(milliseconds / 1000);
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    // Converting 0:60 to 1:00
    if (seconds === 60) {
      seconds = 0;
      minutes++;
    }

    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${minutes}:${seconds}`;
  };

  static storeAppVersion(ver) {
    version = ver;
  }

  static skipUrlEncode() {
    return version >= versionBar;
  }
}

export default AppHelper;
